import { ReactNode } from 'react'

import { useSubscriptionStatus } from '../hooks/use-subscription-status'
import { SubscriptionWall } from './subscription-wall'

export function SubscriptionGate({ children }: { children: ReactNode }) {
  const { data, isLoading, isError } = useSubscriptionStatus()

  if (isLoading) {
    return (
      <div className="flex h-full min-h-[40vh] items-center justify-center text-muted-foreground">
        Vérification de votre abonnement…
      </div>
    )
  }

  if (isError || !data) {
    return <SubscriptionWall status={null} />
  }

  if (data.blocked) {
    return <SubscriptionWall status={data} />
  }

  return <>{children}</>
}
